module.exports = __webpack_public_path__ + "media/images/link-2-c410632f5a69b82ed0870684ae8e0f12.png";